import { SET_APP_STATE, CLEAR_APP_STATE } from "./navigationActionTypes";

const savedState = sessionStorage.getItem("appState");

const initialState = savedState
  ? JSON.parse(savedState)
  : {
      source: null,
      values: {},
      redirectTo: null,
      page: null,
    };

export const navigationReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_APP_STATE:
      return {
        ...state,
        source: action.payload.source || null,
        values: action.payload.values || {},
        redirectTo: action.payload.redirectTo || null,
        page: action.payload.page || null,
      };

    case CLEAR_APP_STATE:
      return {
        source: null,
        values: {},
        redirectTo: null,
        page: null,
      };

    default:
      return state;
  }
};
